import React,{Component} from 'react';
import {connect} from 'react-redux';
import BlogCard from '../shared/BlogCard';
import {Helmet} from 'react-helmet';

class Blogs extends Component{
    componentDidMount(){
        document.body.scrollTo(0,0);
        return document.documentElement.scrollTo(0,0);
    }
    render(){
        return (
            <section className="blog">
                <Helmet>
                    <title>Blog Articles</title>
                </Helmet>
                <div className="container">
                    <div className="row">

                        <div className="col-12 col-sm-12 col-md-12">
                        <div className="blog_heading">
                        <h3>More Blog articles</h3>
                        <div className="blog_divider" />
                        </div>
                        </div>
                        {
                            this.props.blogs.map((blog,index) => (
                                <div className="col-12 col-sm-3 col-md-3" key={index}>
                                    <BlogCard data={blog}/>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </section>
        )
    }
};
const mapToProps = state => ({
    blogs:state.blogs.blogs
});
export default connect(mapToProps,null)(Blogs);